import React, { createContext, useContext, useState } from 'react';

const WalkthroughChefContext = createContext();

export const WalkthroughChefProvider = ({ children }) => {
    const [walkthroughMessage, setWalkthroughMessage] = useState('');
    const [walkthroughSubMessage, setWalkthroughSubMessage] = useState('');
    const [walkthroughChefState, setWalkthroughChefState] = useState('talking');
    const [isWalkthroughActive, setIsWalkthroughActive] = useState(false);
    const [walkthroughPosition, setWalkthroughPosition] = useState('right');
    const [showNextButton, setShowNextButton] = useState(false);
    const [onNextHandler, setOnNextHandler] = useState(null);
    const [showBackButton, setShowBackButton] = useState(false);
    const [onBackHandler, setOnBackHandler] = useState(null);

    const setWalkthroughChef = (message, subMessage, chefState, position, showNext = false, onNext = null, showBack = false, onBack = null) => {
        setWalkthroughMessage(message);
        setWalkthroughSubMessage(subMessage);
        setWalkthroughChefState(chefState || 'talking');
        setWalkthroughPosition(position || 'right');
        setIsWalkthroughActive(true);
        setShowNextButton(showNext);
        setOnNextHandler(() => onNext);
        setShowBackButton(showBack);
        setOnBackHandler(() => onBack);
    };

    const clearWalkthroughChef = () => {
        setWalkthroughMessage('');
        setWalkthroughSubMessage('');
        setWalkthroughChefState('talking');
        setIsWalkthroughActive(false);
        setShowNextButton(false);
        setOnNextHandler(null);
        setShowBackButton(false);
        setOnBackHandler(null);
    };

    return (
        <WalkthroughChefContext.Provider
            value={{
                walkthroughMessage,
                walkthroughSubMessage,
                walkthroughChefState,
                isWalkthroughActive,
                walkthroughPosition,
                showNextButton,
                onNextHandler,
                showBackButton,
                onBackHandler,
                setWalkthroughChef,
                clearWalkthroughChef
            }}
        >
            {children}
        </WalkthroughChefContext.Provider>
    );
};

export const useWalkthroughChef = () => {
    const context = useContext(WalkthroughChefContext);
    if (!context) {
        throw new Error('useWalkthroughChef must be used within a WalkthroughChefProvider');
    }
    return context;
};

